import { API_BASE, ApiError } from '@/api/client';
import i18n from '@/i18n';
// Отправка ошибок фронтенда на сервер (→ лог + Sentry), с ограничением частоты.
import { androidAppVersion } from './androidApp';

let sent = 0;
export function reportError(message: string, stack?: string): void {
  if (sent++ > 20) return;
  void fetch(`${API_BASE}/api/v1/client-errors`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      message: message.slice(0, 1000),
      stack: stack?.slice(0, 5000),
      url: location.pathname,
      ua: navigator.userAgent.slice(0, 300),
      app: androidAppVersion() ? `android-${androidAppVersion()}` : undefined,
    }),
    // keepalive запрещён для запросов на другой адрес с предзапросом CORS (приложение: API на сайте игры)
    keepalive: !API_BASE,
  }).catch(() => undefined);
}

/** Человекочитаемый текст ошибки API на текущем языке. */
export function errorText(e: unknown): string {
  if (e instanceof ApiError) {
    if (e.code === 'network') return i18n.t('common:offline');
    const authKey = `auth:errors.${e.code}`;
    if (i18n.exists(authKey)) return i18n.t(authKey);
    if (e.code === 'not_enough_resources') {
      const missing = (e.details as { missing?: Record<string, number> } | undefined)?.missing ?? {};
      const list = Object.entries(missing)
        .map(([k, v]) => `${i18n.t(`common:resources.${k}`, { defaultValue: k })} ${v}`)
        .join(', ');
      return i18n.t('game:missing', { list });
    }
    return e.message;
  }
  if (e instanceof Error) {
    if (/^(offline|failed to fetch|network error|load failed|operation has timed out)$/i.test(e.message))
      return i18n.t('common:offline');
    return e.message;
  }
  return i18n.t('common:unknownError');
}
